import { render, staticRenderFns } from "./personalRequests.vue?vue&type=template&id=4b1c7734&scoped=true"
import script from "./personalRequests.vue?vue&type=script&lang=js"
export * from "./personalRequests.vue?vue&type=script&lang=js"
import style0 from "./personalRequests.vue?vue&type=style&index=0&id=4b1c7734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c7734",
  null
  
)

export default component.exports